/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeClockDayreportCtrl
 */
angular.module('mercury.modules.time.clock')
.controller('TimeClockDayreportCtrl', ["$filter", "reporttime", "$scope", "$stateParams", "title", "TimeClock", function($filter, reporttime, $scope, $stateParams, title, TimeClock) {
  title.set('Punches By Day');

  $scope.totals = {
    totalPay: 0,
    totalLength: 0,
    roles: {}
  };
  $scope.days = [];

  $scope.reporttype = reporttime.reportType();

  var getDayTable = function(day, clocks) {
    var dayGroup = {
      startTime: day,
      totalPay: 0,
      totalLength: 0,
      roles: {}
    };

    angular.forEach(clocks, function(clock) {
      if (!dayGroup.roles[clock.roleId]) {
        dayGroup.roles[clock.roleId] = {
          name: clock.roleName,
          totalPay: 0,
          totalLength: 0,
          staff: {}
        };
      }

      if (!dayGroup.roles[clock.roleId].staff[clock.staffMemberId]) {
        dayGroup.roles[clock.roleId].staff[clock.staffMemberId] = {
          name: clock.staffMemberFirstName + ' ' + (clock.staffMemberLastName || ''),
          totalLength: 0,
          totalPay: 0
        };
      }

      dayGroup.roles[clock.roleId].staff[clock.staffMemberId].totalLength += clock.lengthUnrounded;
      dayGroup.roles[clock.roleId].staff[clock.staffMemberId].totalPay += clock.lengthUnrounded * clock.adjustedHourlyRate;

      dayGroup.roles[clock.roleId].totalLength += clock.lengthUnrounded;
      dayGroup.roles[clock.roleId].totalPay += clock.lengthUnrounded * clock.adjustedHourlyRate;

      dayGroup.totalLength += clock.lengthUnrounded;
      dayGroup.totalPay += clock.lengthUnrounded * clock.adjustedHourlyRate;
    });

    // Convert the roles object and sub-staff objects to arrays and order by name.
    var roleArray = [];
    angular.forEach(dayGroup.roles, function(roleGroup) {
      var staffArray = [];
      angular.forEach(roleGroup.staff, function(staff) {
        staffArray.push(staff);
      });

      roleGroup.staff = $filter('orderBy')(staffArray, 'name');
      roleArray.push(roleGroup);
    });
    dayGroup.roles = $filter('orderBy')(roleArray, 'name');

    return dayGroup;
  };

  var addClockToTotalTable = function(clocks) {
    angular.forEach(clocks, function(clock) {
      if (!$scope.totals.roles[clock.roleId]) {
        $scope.totals.roles[clock.roleId] = {
          name: clock.roleName,
          totalPay: 0,
          totalLength: 0,
          staff: {}
        };
      }

      $scope.totals.roles[clock.roleId].totalLength += clock.lengthUnrounded;
      $scope.totals.roles[clock.roleId].totalPay += clock.lengthUnrounded * clock.adjustedHourlyRate;

      if (!$scope.totals.roles[clock.roleId].staff[clock.staffMemberId]) {
        $scope.totals.roles[clock.roleId].staff[clock.staffMemberId] = {
          name: clock.staffMemberFirstName + ' ' + (clock.staffMemberLastName || ''),
          totalPay: 0,
          totalLength: 0
        };
      }

      $scope.totals.roles[clock.roleId].staff[clock.staffMemberId].totalLength += clock.lengthUnrounded;
      $scope.totals.roles[clock.roleId].staff[clock.staffMemberId].totalPay += clock.lengthUnrounded * clock.adjustedHourlyRate;

      $scope.totals.totalLength += clock.lengthUnrounded;
      $scope.totals.totalPay += clock.lengthUnrounded * clock.adjustedHourlyRate;
    });
  };

  $scope.loading = TimeClock.getAllActive(reporttime.start(), reporttime.end());
  $scope.loading.then(function(allClocks) {
    for (var iter = moment(reporttime.start()); iter.isBefore(reporttime.end()); iter.add(1, 'day')) {

      // Get all the clocks that intersect with this day.
      var effectiveClocks = TimeClock.effectiveClocks(allClocks, iter, iter.clone().add(1, 'day'));

      if (effectiveClocks.length > 0) {
        // Add a day total
        $scope.days.push(getDayTable(iter.format(), effectiveClocks));

        // Add these clocks to the summary table.
        addClockToTotalTable(effectiveClocks);
      }
    }
  });
}]);
